// @flow
import { fork } from 'redux-saga/effects';
import setTable from './setTable';
import setSituation from './setSituation';
import setFirstPairCardTableFold from './setFirstPairCardTableFold';
import setSecondPairCardTableFold from './setSecondPairCardTableFold';

export default function* tableSaga() {
  yield fork(setTable);
  yield fork(setSituation);
  yield fork(setFirstPairCardTableFold);
  yield fork(setSecondPairCardTableFold);
}
